import DashboardBuilderPage from './DashboardBuilderPage';
import { DashboardDataProvider, DashboardUIProvider } from './context';

const DashboardBuilderPageWithProvider = () => (
  <DashboardDataProvider>
    <DashboardUIProvider>
      <DashboardBuilderPage />
    </DashboardUIProvider>
  </DashboardDataProvider>
);

export default DashboardBuilderPageWithProvider;
